<template>
  <div>
    <span class="icon icon-user-check ml-2 mt-1"></span>
    <span class="icon icon-lock ml-2 mt-1"></span>
    <br />
    <div class="form-check form-check-inline">
      <input
        type="checkbox"
        id="cb1-all"
        class="ml-2"
        v-model="selected"
        @change="emitSelection"
        value="1"
        :disabled="deselected"
      />

      <input
        type="checkbox"
        id="cb2-all"
        class="ml-2"
        v-model="deselected"
        @change="emitSelectionlock"
        value="2"
      />
    </div>
  </div>
</template>

<script>
import { mapActions, mapState, mapGetters } from "vuex";

export default {
  name: "SelectAll",
  data() {
    return {
      selected: this.selectAll,
      deselected: this.selectAllLock,
    };
  },
  computed: {
    ...mapState("modTipshiftReport", [
      "tipshift",
      "selectAll",
      "selectAllLock",
    ]),
    ...mapGetters(["modTipshiftReport", ["getAllSelected"]]),
  },
  methods: {
    ...mapActions("modTipshiftReport", [
      "actSaveTipshift",
      "actGetTipshift",
      "actGetSelectAll",
      "actGetSelectAllLock",
    ]),

    emitSelection: function () {
      this.actGetSelectAll(this.selected ? true : false)
        .then(() => {})
        .catch((response) => {
          this.error.flag = true;
          this.error.class = "is-invalid";
          this.error.message =
            "No se pudo seleccionar todos los registros: " + response;
        });
    },
    emitSelectionlock: function () {
      if (this.deselected) {
        this.selected = !this.deselected;
        console.log("seleccionados todos");
      }
      this.actGetSelectAllLock(this.deselected ? true : false)
        .then(() => {})
        .catch((response) => {
          this.error.flag = true;
          this.error.class = "is-invalid";
          this.error.message =
            "No se pudo seleccionar todos los registros: " + response;
        });
    },
  },
  created: function () {},

  updated() {
    //this.selected = this.selectAll;
  },

  watch: {
    // Si se deselcciona una casilla la casilla del encabezado tambien se deselecciona
    selectAll: function (newVal) {
      // watch it
      this.selected = newVal;
    },
  },
};
</script>

<style lang="scss" scoped>
input[type="checkbox"] + label {
  margin-left: 0px !important;
  //display: none;
}
</style>